import type { FetchOptions } from 'ofetch'
import { useApplicationType, usePlatform } from '@st/use/composables'
import { useApiEventBus } from '@st/api-base/composables/useApiEventBus'

export function useApiConfig() {
  const optionsFromConfig = useRuntimeConfig().public.api

  const { baseURL: defaultBaseUrl, serverBaseURL } = optionsFromConfig

  const platformBaseURL =
    (import.meta.client ? defaultBaseUrl : serverBaseURL) || defaultBaseUrl

  const bus = useApiEventBus()

  const { platform } = usePlatform()
  const { isTelegramMiniApp, isPwa } = useApplicationType()

  function getXPlatform() {
    if (isTelegramMiniApp.value) {
      return 'telegramMiniApp'
    }
    if (isPwa.value) {
      return 'pwa'
    }
    return `${platform.value}site`
  }

  function normalizeBaseURL(url: string) {
    if (import.meta.client && url.startsWith('/')) {
      return `${window.location.origin}${url}`
    }
    return url
  }

  function createApiConfig(options: FetchOptions = {}): FetchOptions {
    const mergedConfig: FetchOptions = {
      ...options,
      credentials: 'include',
      onRequest: (context) => {
        bus.emit('request', context)
        if (options.onRequest) options.onRequest(context)
      },
      onResponse: (context) => {
        bus.emit('response', context)
        if (options.onResponse) options.onResponse(context)
      },
      onRequestError: (context) => {
        bus.emit('requestError', context)
        if (options.onRequestError) options.onRequestError(context)
      },
      onResponseError: (context) => {
        bus.emit('responseError', context)
        if (options.onResponseError) options.onResponseError(context)
      },
    }

    mergedConfig.baseURL = normalizeBaseURL(options.baseURL || platformBaseURL)

    mergedConfig.headers = {
      ...mergedConfig.headers,
      'X-platform': getXPlatform(),
    }

    return mergedConfig
  }

  return { createApiConfig }
}
